// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rRjBv","type":"styles_type__1rXhy","choices":"styles_choices__2dbw2"};